import {
  GET_SIM_INVENTORY,
  GET_SIM_DISTRIBUTION,
  GET_ADMIN_USER_1,
  MANAGE_SIM_INVENTORY,
  GET_USER_TYPES,
  GET_SIM_USER_DISTRIBUTION,
  GET_USER_SIM_STOCK,
  SAVE_INVOICE_SIM,
  CHECK_SIM_INVOICE,
  GET_SIM_SEARCH,
  GET_SIM_ICCID,
  GET_SELLING_PRICE,
  MANAGE_BULK_SIM_INVENTORY,
  GET_SIM_COUNT,
   GET_MULTISELLING_PRICE,
  MANAGE_BULK_MULTI_SIM_INVENTORY,
  CHECK_MULTI_SIM_INVOICE
} from "../../admin-constants";
import simService from "../../../services/admin/sim.service";
import { showLoader,hideLoader } from "../../common/actions";
import { showModal } from "../../modal/actions";


export const getSimInventory = (data) => async (dispatch) => {
  try {
    const resultData = await simService.getSimInventory(data);
    dispatch({
      type: GET_SIM_INVENTORY,
      payload: resultData?.status && resultData?.data ? resultData.data : [],
    });
  } catch (err) {
    console.log(err);
  }
};

export const getSimDistribution = (data) => async (dispatch) => {
  try {
    const resultData = await simService.getSimDistribution(data);
    if (resultData?.status) {
      dispatch({
        type: GET_SIM_DISTRIBUTION,
        payload: resultData,
      });
    } else {
    }
  } catch (err) {
    console.log(err);
  }
};

export const getDspUser1 = () => async (dispatch) => {
  try {
    const resultData = await simService.getDspUser1();
    dispatch({
      type: GET_ADMIN_USER_1,
      payload: resultData?.status && resultData?.data ? resultData.data : [],
    });
  } catch (err) {
    console.log(err);
  }
};

// export const getSimStock = (data) => async (dispatch) => {
//   try {
//     const resultData = await simService.getSimStock(data);

//     dispatch({
//       type: GET_SIM_STOCK,
//       payload: resultData?.status && resultData?.data ? resultData.data : [],
//     });
//   } catch (err) {
//     console.log(err);
//   }
// };

export const getSimUserDistribution = () => async (dispatch) => {
  try {
    const resultData = await simService.getSimUserDistribution();

    dispatch({
      type: GET_SIM_USER_DISTRIBUTION,
      payload: resultData?.status && resultData?.data ? resultData.data : [],
    });
  } catch (err) {
    console.log(err);
  }
};

export const getUserSimStock = () => async (dispatch) => {
  try {
    const resultData = await simService.getUserSimStock();
    dispatch({
      type: GET_USER_SIM_STOCK,
      payload: resultData?.status && resultData?.data ? resultData.data : [],
    });
  } catch (err) {
    console.log(err);
  }
};

export const manageSimInventory =
  (data, setSubmitting, resetForm) => async (dispatch) => {

    try{
        dispatch(showLoader());

    const resultData = await simService.manageSimInventory(data);

    if (resultData?.status) {
      dispatch({
        type: MANAGE_SIM_INVENTORY,
        payload: resultData ? resultData : {},
      });
                         dispatch(showModal({
                  title: "Success",
                  message: "Updated successfully",
                  iconType: "success",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
      // const resultData1 = await simService.getSimStock(data);
      // dispatch({
      //   type: GET_USER_SIM_STOCK,
      //   payload:
      //     resultData1?.status && resultData1?.data ? resultData1.data : [],
      // });
    } else {
            dispatch(showModal({
                  title: "Failure",
                  message: "Something wrong while updating",
                  iconType: "error",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
      dispatch({
        type: MANAGE_SIM_INVENTORY,
        payload: resultData ? resultData : {},
      });
    }
    setSubmitting(false);
    resetForm();
    }catch(err){
      comsole.log(err)
    }
        finally {
      dispatch(hideLoader());
    }
  };

export const manageBulkSimInventory =
  (data, setSubmitting, resetForm) => async (dispatch) => {

    let resultData = null;
    try {
      dispatch(showLoader());
      dispatch({
        type: MANAGE_BULK_SIM_INVENTORY,
        payload: null,
      });

      resultData = await simService.manageBulkSimInventory(data);

      if (resultData?.status) {
        dispatch({
          type: MANAGE_BULK_SIM_INVENTORY,
          payload: resultData ? resultData : {},
        });
   
      } else {
        dispatch(
          showModal({
            title: "Failure",
            message: resultData?.message?.message || "Something wrong while updating",
            iconType: "error",
            autoClose: true,
            autoCloseTime: 1800,
          })
        );
        dispatch({
          type:  MANAGE_BULK_SIM_INVENTORY,
          payload: resultData ? resultData : {},
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
       
      if (typeof setSubmitting === "function") {
        setSubmitting(false);
      }
      if (typeof resetForm === "function") {
        resetForm();
      }
      dispatch(hideLoader());
      return resultData;
    }
  };

export const getUserTypes = (data) => async (dispatch) => {
  try {
    const resultData = await simService.getUserTypes(data);

    dispatch({
      type: GET_USER_TYPES,
      payload:
        resultData?.status && resultData?.message ? resultData.message : [],
    });
  } catch (err) {
    console.log(err);
  }
};

export const saveInvoiceSim = (data, resetPage) => async (dispatch) => {
  try {
    dispatch(showLoader());
    const resultData = await simService.saveInvoiceSim(data);
    if (resultData) {
      dispatch({
        type: SAVE_INVOICE_SIM,
        payload: resultData,
      });
      resetPage();
                               dispatch(showModal({
                  title: "Success",
                  message: "Updated successfully",
                  iconType: "success",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
    }else{
            dispatch(showModal({
                  title: "Failure",
                  message: "Something wrong while updating",
                  iconType: "error",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
    }
  } catch (err) {
    console.log(err);
  }
   finally {
      dispatch(hideLoader());
    }
};

export const checkSimInvoice = (data) => async (dispatch) => {
  try {
    const resultData = await simService.checkSimInvoice(data);

    dispatch({
      type: CHECK_SIM_INVOICE,
      payload: resultData,
    });
    return resultData;
  } catch (err) {
    console.log(err);
    return null;
  }
};


export const getSellingPrice = (data) => async (dispatch) => {
  try {
    const resultData = await simService.getSellingPrice(data);

    dispatch({
      type: GET_SELLING_PRICE,
      payload: resultData?.status && resultData?.data ? resultData.data : [],
    });
    return resultData;
  } catch (err) {
    console.log(err);
    return null;
  }
};


export const getSimSearch = (data) => async (dispatch) => {
  try {
    const resultData = await simService.getSimSearch(data);
    dispatch({
      type: GET_SIM_SEARCH,
      payload: resultData?.status && resultData?.data ? resultData.data : [],
    });
  } catch (err) {
    console.log(err);
  }
};

export const getIccid = (data) => async (dispatch) => {
  try {
    const resultData = await simService.getIccid(data);
    dispatch({
      type: GET_SIM_ICCID,
      payload: resultData?.status && resultData?.data ? resultData.data : [],
    });
    return resultData;
  } catch (err) {
    console.log(err);
    return null;
  }
};
export const getSimCount = (data) => async (dispatch) => {
  try {
    const resultData = await simService.getSimCount(data);
 
   dispatch({
      type: GET_SIM_COUNT,
      payload: resultData?.status && resultData?.data ? resultData.data : [],

    });
    
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const manageBulkMultiSimInventory =
  (data, setSubmitting, resetForm) => async (dispatch) => {
    console.log("data", data);
    let resultData = null;
    try {
      dispatch(showLoader());
      dispatch({
        type: MANAGE_BULK_MULTI_SIM_INVENTORY,
        payload: null,
      });

      resultData = await simService.manageBulkMultiSimInventory(data);

      if (resultData?.status) {
        dispatch({
          type: MANAGE_BULK_MULTI_SIM_INVENTORY,
          payload: resultData ? resultData : {},
        });
      } else {
        dispatch(
          showModal({
            title: "Failure",
            message:
              resultData?.message?.message || "Something wrong while updating",
            iconType: "error",
            autoClose: true,
            autoCloseTime: 1800,
          }),
        );
        dispatch({
          type: MANAGE_BULK_MULTI_SIM_INVENTORY,
          payload: resultData ? resultData : {},
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      if (typeof setSubmitting === "function") {
        setSubmitting(false);
      }
      if (typeof resetForm === "function") {
        resetForm();
      }
      dispatch(hideLoader());
      return resultData;
    }
  };

  export const checkMultiSimInvoice = (data) => async (dispatch) => {
  console.log("checkSimInvoice data", data);
  try {
    const resultData = await simService.checkMultiSimInvoice(data);
    
    dispatch({
      type: CHECK_MULTI_SIM_INVOICE,
      payload: resultData,
    });
    return resultData;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getmultiSellingPrice = (data) => async (dispatch) => {
  try {
    const resultData = await simService.getmultiSellingPrice(data);

   
    dispatch({
      type: GET_MULTISELLING_PRICE,
      payload: resultData?.status && resultData?.message ? resultData.message : [],
    });
    return resultData.message;
  } catch (err) {
    console.log(err);
    return null;
  }
};


